export const extraIncomeTexts = {
  extraHours: {
    title: 'Extra Hours',
    tooltip: 'Sendit Fee only applies to hours worked.',
    fields: {
      timeSpent: {
        label: 'Additional Time Spent',
        suffix: 'hours:minutes',
        errorMessage: 'Time Spent is required',
      },
      totalAmount: {
        label: 'Additional Amount',
        suffix: '$',
        errorMessage: 'Total Amount is required',
      },
    },
  },
  additionalCharges: {
    title: 'Additional Charges',
    tooltip: 'Sendit does not charge a fee for any bonuses or travel expenses.',
    fields: {
      bonus: {
        label: 'Bonus',
        suffix: '$',
        errorMessage: 'Bonus is required',
      },
      travelExpenses: {
        label: 'Travel Expenses',
        suffix: '$',
        errorMessage: 'Travel Expenses is required',
      },
    },
  },
  saveButton: {
    label: 'Save',
  },
  successMessage: 'Bonus has been successfully added.',
};
